import { useTranslation } from 'react-i18next'

import { Check } from 'lucide-react'

const POINT_KEYS = ['1', '2', '3', '4', '5'] as const

export function WhoItsForSection() {
    const { t } = useTranslation()

    return (
        <div className='mx-auto mt-12 grid max-w-[1180px] grid-cols-1 gap-5 px-[22px] md:mt-16 md:grid-cols-2 md:gap-12 md:px-10'>
            <div className='flex flex-col gap-2.5'>
                <h2 className='m-0 text-[28px] font-medium leading-[1.15] tracking-[-0.8px] text-[#F4502A] md:text-[42px]'>
                    {t('foodCost.whoItsFor.title')}
                </h2>
                <p className='m-0 text-[17px] font-medium leading-snug text-[#17130E] md:text-[20px]'>
                    {t('foodCost.whoItsFor.answerCapsule')}
                </p>
                <p className='m-0 text-[15px] leading-relaxed text-[#5C5548] md:text-[17px] md:leading-[1.7]'>
                    {t('foodCost.whoItsFor.description1')} {t('foodCost.whoItsFor.description2')}
                </p>
            </div>

            <ul className='m-0 flex list-none flex-col p-0'>
                {POINT_KEYS.map(pointKey => (
                    <li
                        key={pointKey}
                        className='flex items-start gap-3 border-t border-[#D8CFC0] py-3.5 last:border-b md:py-4'
                    >
                        <Check
                            className='mt-0.5 h-[18px] w-[18px] shrink-0 text-[#F4502A]'
                            strokeWidth={2.75}
                            aria-hidden
                        />
                        <span className='text-[15px] font-medium leading-snug text-[#17130E] md:text-base'>
                            {t(`foodCost.whoItsFor.points.${pointKey}`)}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    )
}
